<template>
    <div class="md-layout-item md-size-33 pb-2 pt-2">
        <div class="flex items-center justify-between w-full">
            <md-checkbox v-model="day.isActive" @change="handleDay">{{ day.name }}</md-checkbox>
            <div class="flex items-center" v-if="day.isActive">
                <div class="buttons-actions">
                    <md-button class="md-icon-button md-raised md-default"
                        @click="apply('all')">
                        <i class="md-icon fa fa-arrows-alt-v"/>
                    </md-button>
                    <md-tooltip md-direction="top">Appliquer à tous les autres jours</md-tooltip>
                </div>
				<div class="buttons-actions" v-if="day.number !== 0">
					<md-button class="md-icon-button md-raised md-default"
							   @click="apply('previous')">
						<i class="md-icon fa fa-chevron-left"/>
					</md-button>
					<md-tooltip md-direction="top">Appliquer au jour précédent</md-tooltip>
				</div>
                <div class="buttons-actions" v-if="day.number !== 5">
                    <md-button class="md-icon-button md-raised md-default"
                        @click="apply('next')">
                        <i class="md-icon fa fa-chevron-right"/>
                    </md-button>
                    <md-tooltip md-direction="top">Appliquer au jour suivant</md-tooltip>
                </div>
            </div>
        </div>
        <template v-if="day.isActive">
            <div class="md-layout items-center mt-2">
                <div class="md-layout-item md-size-50">
                    <md-field class="md-invalid md-time">
                        <label>Début</label>
                        <md-input class="input-time" v-model="day.schedules[0].start" type="time"></md-input>
						<validation-error :errors="apiValidationErrors.start_0" />
                    </md-field>
                </div>
                <div class="md-layout-item md-size-50">
                    <md-field class="md-invalid md-time">
                        <label>Fin</label>
                        <md-input class="input-time" v-model="day.schedules[0].end" type="time"></md-input>
						<validation-error :errors="apiValidationErrors.end_0" />
                    </md-field>
                </div>
            </div>
            <div class="md-layout items-center mt-1">
                <div class="md-layout-item md-size-50">
                    <md-field class="md-invalid md-time">
                        <label>Début</label>
                        <md-input class="input-time" v-model="day.schedules[1].start" type="time"></md-input>
						<validation-error :errors="apiValidationErrors.start_1" />
                    </md-field>
                </div>
                <div class="md-layout-item md-size-50">
                    <md-field class="md-invalid md-time">
                        <label>Fin</label>
                        <md-input class="input-time" v-model="day.schedules[1].end" type="time"></md-input>
						<validation-error :errors="apiValidationErrors.end_1" />
                    </md-field>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import formMixin from "@/mixins/form-mixin";
import { ValidationError } from "@/components";

export default {
    name: "DayRow",
	components: {
		ValidationError
	},
	mixins: [formMixin],
    props: {
        day: Object,
		errors: Array,
    },
    methods: {
        handleDay() {
            if(!this.day.isActive) {
                let schedules = this.day.schedules.find(schedule => schedule.start !== null || schedule.end !== null)
                if(schedules) {
                    this.$emit('disable', { origin: this.day })
                }
            }
        },
        apply(target) {
            this.$emit('apply', { target: target, origin: this.day })
        }
    },
	watch: {
    	errors: function(newVal, oldVal) {
			this.resetApiValidation()
    		if(newVal !== oldVal) {
    			let errors = []
				newVal.map(error => {
					let parts = error.source.pointer.split('.')
					if(parseInt(parts[1]) === this.day.number) {
						errors.push({
							source: { pointer: '/data/attributes/' + parts[3] + '_' + parts[2] },
							detail: error.detail
						})
					}
				})
				this.setApiValidation(errors)
			}
		}
	}
}
</script>

<style scoped lang="scss">
::v-deep {
    .buttons-actions {
        .md-button {
            width: auto;
            padding: 7.5px 5px;

            .md-icon {
                font-size: .875rem !important;
                min-width: .875rem !important;
                height: .875rem !important;
                color: #FFFFFF !important;
            }
        }
    }

    .md-time {
        label {
            top: -0.8rem !important;
            font-size: 0.6875rem !important;
        }
        .input-time {
            padding-top: 0 !important;
            margin-bottom: -3px !important;
        }
    }
}
</style>
